export const environment = {
  production: true,
  apiRootUrl: 'https://asia-northeast1-facere-facility01.cloudfunctions.net',
  firebase: {
    apiKey: "AIzaSyC3DyKzyUFgsqlrRq89ltGLob8X2vF7RDA",
    authDomain: "facere-facility01.firebaseapp.com",
    projectId: "facere-facility01",
    storageBucket: "facere-facility01.appspot.com",
    messagingSenderId: "505899037751",
    appId: "1:505899037751:web:e66c6d0bab1a97b7a43bb2",
    measurementId: "G-XE8FGCYYQD"
  },
  googleAuthClientId: '505899037751-qn6ljvng8u8v5dc8n0s3srivi161t8ft.apps.googleusercontent.com',

  //URL
  devUrl: "https://facere-facility-dev.web.app/",
  prodUrl: "https://facere-facility-prod.web.app/",
  googleMapsApiKey: 'AIzaSyDApqaJTuQkwf_oEKDmPBQ2OryyZCmEXNg',
  qrBaseUrl: 'https://facere-facility01-qrreader.web.app/',
};
